"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientProfilerInit = exports.sendInBeacon = exports.clientProfilerConfigPropTypes = void 0;
/* eslint-env browser */
/* eslint-disable global-require, no-console */
const react_1 = require("react");
const prop_types_1 = __importDefault(require("prop-types"));
// Shared prop types for the client profiler config params shape
exports.clientProfilerConfigPropTypes = {
    clientProfilerConfig: prop_types_1.default.shape({
        beaconUrl: prop_types_1.default.string.isRequired,
        staticDimensions: prop_types_1.default.shape({
            hostId: prop_types_1.default.string.isRequired,
            pageName: prop_types_1.default.string.isRequired,
        }),
        trackedEventDetails: prop_types_1.default.shape({
            eventDetails: prop_types_1.default.arrayOf(prop_types_1.default.shape({})),
        }),
    }),
};
/**
 * Send the initial "IN" beacon before loading the client profiler. Mimics the client profiler
 * "tracking pixel" logic in the PRE, but with `fetch()`. Does nothing if `fetch()` is undefined.
 *
 * @see https://gitlab.zgtools.net/zillow/legacy-zillow-web/zillow-web/-/blob/d0b629e6d83061fb583c5af6f7d658fcc481a13d/webapp.war/WEB-INF/PageWrapper.html#L364
 *
 * @param {object} Opts object
 * @param {string} opts.beaconUrl The client profiler beacon URL
 * @param {object} opts.staticDimensions Static dimensions object to include with the beacon payload
 *
 * @returns {Promise} A promise that resolves after the beacon is sent (or immediately if `fetch()`
 * is undefined)
 */
const sendInBeacon = ({ beaconUrl, staticDimensions }) => {
    if (typeof fetch !== 'undefined') {
        const payload = encodeURIComponent(JSON.stringify({
            eventsStart: ['clientProfilerLoaded'],
            staticDimensions,
        }));
        return fetch(`${beaconUrl}/?p=${payload}`).catch(e => {
            console.error(e);
        });
    }
    return Promise.resolve();
};
exports.sendInBeacon = sendInBeacon;
/**
 * Initialize the client profiler singleton on the window
 */
class ClientProfilerInit extends react_1.Component {
    componentDidMount() {
        const { clientProfilerConfig } = this.props;
        // Skip if already initialized, e.g., in Next apps rendered inside the SRP page lightbox
        if (window.ClientProfiler) {
            return;
        }
        // Send the initial "IN" beacon so we know if client profiler fails to load
        (0, exports.sendInBeacon)(clientProfilerConfig);
        // Only load the client profiler module client-side b/c it has window dependencies
        const ClientProfiler = require('@zillow/client-profiler-core').default;
        // Create and configure a new client profiler and attach it to the window. Explicitly
        // enable internal beaconing.
        window.ClientProfiler = new ClientProfiler({
            ...clientProfilerConfig,
            enableBeaconing: true,
        });
    }
    render() {
        return null;
    }
}
exports.ClientProfilerInit = ClientProfilerInit;
ClientProfilerInit.propTypes = exports.clientProfilerConfigPropTypes;
